import { challengeRef, taskRef } from 'lib/firebase';

const deleteTask = (key, challengeKey, phase) =>
  Promise.all([
    challengeRef(challengeKey).child(`tasks/${phase}/${key}`).remove(),
    taskRef(key).remove()
  ]);

export default deleteTask;
